import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/ui/hover-card";
import { useLocation } from "react-router";
import type { NavListProps } from "../types";
import { isPathActive } from "../utils/path-matcher";
import { NavItem } from "./nav-item";

export function NavList({ data, depth = 0 }: NavListProps) {
	const hasChild = data.children && data.children.length > 0;
	const location = useLocation();
	
	// 收集所有菜单路径用于智能匹配
	const allMenuPaths: string[] = [];
	const collectPaths = (item: typeof data) => {
		if (item.path) allMenuPaths.push(item.path);
		item.children?.forEach(collectPaths);
	};
	collectPaths(data);
	
	const isActive = isPathActive(location.pathname, data.path, allMenuPaths);

	if (data.hidden) {
		return null;
	}

	const renderNavItem = () => {
		return (
			<NavItem
				key={data.title}
				// data
				path={data.path}
				title={data.title}
				caption={data.caption}
				info={data.info}
				icon={data.icon}
				auth={data.auth}
				// state
				disabled={data.disabled}
				active={isActive}
				// options
				hasChild={hasChild}
				depth={depth}
			/>
		);
	};

	const renderRootItemWithHoverCard = () => {
		return (
			<HoverCard openDelay={100}>
				<HoverCardTrigger>{renderNavItem()}</HoverCardTrigger>
				<HoverCardContent side={depth === 1 ? "bottom" : "right"} sideOffset={10} className="p-1">
					{data.children?.map((child) => (
						<NavList key={child.title} data={child} depth={depth + 1} />
					))}
				</HoverCardContent>
			</HoverCard>
		);
	};

	return <li className="list-none">{hasChild ? renderRootItemWithHoverCard() : renderNavItem()}</li>;
}
